import { useEffect } from "react";

import { PricingContentContextProvider } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { StrategyCollectionPricingPageTemplate } from "@/templates/collections/strategy/pricing/strategy-collection-pricing-page.template.tsx";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { UserLocale } from "@/utils/useGeoCurrency.ts";

import { AppPricingData } from "../../../../contentful/index.tsx";

export interface StrategyCollectionPricingPageProps {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
}

export const StrategyCollectionPricingPage = (
    props: StrategyCollectionPricingPageProps
) => {
    const { pricingContent, pricing, countryCode } = props;

    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <PricingContentContextProvider
            productId="strategy-collection"
            pricingContent={pricingContent}
        >
            <StrategyCollectionPricingPageTemplate />
        </PricingContentContextProvider>
    );
};
